'use strict';


/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;

    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    // TODO: The confirmation alert should be styled as the FSD

    var messageMarkup;
    if (data.success && (button.is('.bbw-pdp__wishlist-toggle-cta') || button.is('.js-pc-add-to-wish-list'))) {
        messageMarkup = `
            <img class="add-to-wishlist-messages__icon" src="${button.data('addedIconUrl')}" />
            <span>${data.msg}</span>
        `;
    } else {
        messageMarkup = data.msg;
    }

    $('.add-to-wishlist-messages').empty()
        .append(`<div class="add-to-wishlist-alert text-center ${status}">${messageMarkup}</div>`);

    setTimeout(function () {
        $('.add-to-wishlist-messages').empty();
        button.removeAttr('disabled');
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $(document).on('click', '.add-to-wish-list', function (e) {
            e.preventDefault();
            var $this = $(this);
            var url = $(this).data('href');
            var button = $(this);
            var pid = $(this).closest('.product-detail').find('.product-id').html().trim();
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    if ($this.is('.bbw-pdp__wishlist-toggle-cta')) {
                        $this.addClass('bbw-pdp__wishlist-toggle-cta--added');
                        $this.attr('aria-label', 'Wishlist Added to My Love-It List');
                    }
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    },
    productCardAddToWishlist: function () {
        $('.js-pc-add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var url = $this.attr('href');
            var pid = $this.data('pid');

            if (!url || !pid) {
                return;
            }

            $.spinner().start();

            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid : pid
                }
            }).done(function (data) {
                displayMessage(data, $this);

                if (data.success) {
                    $this.addClass('d-none');
                    $this.parent().find('.js-pc-added-to-wish-list').removeClass('d-none');
                }
            }).fail(function (err) {
                displayMessage(err, $this);
            }).always(function () {
                $.spinner().stop();
            });
        });
    },
    appendWishlistContainer: function () {
        if ($('.add-to-wishlist-messages').length === 0) {
            $('body').append(
                '<div class="add-to-wishlist-messages" aria-live="polite" role="status"></div>'
            );
        }
    }
};
